<template>
  <div class="base_box">
    <div class="body_box">
      <div class="banner">
        <MyBanner> </MyBanner>
      </div>
      <div class="main">
        <!-- 1 -->
        <div class="mz_info">
          <el-row :gutter="20">
            <el-col :xs="24" :sm="24" :md="16" :lg="16" :xl="16">
              <div class="history_box animated fadeInLeft" v-if="articleList[0]">
                <div class="history">
                  <div class="title">{{common.dictionary("文章分类", articleList[0].title)}}
                    <!-- 更多 -->
                    <span class="moreBtn" @click="toPage('/articleList',4)">{{$t("welcome.more")}} <i class="el-icon-arrow-right"></i> </span>
                    <div class="line"></div>
                  </div>
                  <ul class="roll">
                    <li v-for="(item, i) in articleList[0].record" @click="toArticle(item)" :key="i">
                      <i class="el-icon-star-off"></i>
                      <div> {{item.title_name}}</div>
                      <span>{{item.create_time | timeFilter}}</span>
                    </li>
                  </ul>
                </div>
                <div class="history_img">
                  <img src="@/assets/img/img_1.jpg" alt="">
                </div>
              </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
              <div class="news animated zoomIn" v-if="articleList[1]">
                <div class="title">{{common.dictionary("文章分类", articleList[1].title)}}
                  <!-- 更多 -->
                  <span class="moreBtn" @click="toPage('/articleList',4)">{{$t("welcome.more")}} <i class="el-icon-arrow-right"></i> </span>
                  <div class="line_two"></div>
                </div>
                <ul class="roll">
                  <li v-for="(item, i) in articleList[1].record" @click="toArticle(item)" :key=" i">
                    <i class="el-icon-star-off"></i>
                    <div> {{item.title_name}}</div> <span>{{item.create_time | timeFilter}}</span>
                  </li>
                </ul>
              </div>
              <div class="news animated zoomIn" v-if="articleList[0] && !articleList[1]">
                <img src="@/assets/img/img_2.jpg" alt />
              </div>
            </el-col>
          </el-row>
        </div>
        <!-- 3 -->
        <div class="card_main animated fadeInUp">
          <el-row :gutter="20">
            <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
              <div class="item_card" @click="toPage('/map',1)">
                <div class="card_title">
                  <!-- 妈祖庙地图 -->
                  {{$t("menu.map")}}
                </div>
                <div class="card_info">
                  <!-- 世界妈祖庙分布地图 -->
                  {{$t("welcome.t1")}}
                </div>
                <img src="@/assets/img/card1.png" alt />
              </div>
            </el-col>
            <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
              <div class="item_card" @click="toPage('/chart',2)">
                <div class="card_title">
                  <!-- 图表统计 -->
                  {{$t("menu.chart")}}
                </div>
                <div class="card_info">
                  <!-- 世界妈祖庙时间与空间统计图表 -->
                  {{$t("welcome.t2")}}
                </div>
                <img src="@/assets/img/card2.png" alt />
              </div>
            </el-col>
            <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
              <div class="item_card" @click="toPage('/list',3)">
                <div class="card_title">
                  <!-- 妈祖庙列表 -->
                  {{$t("menu.list")}}
                </div>
                <div class="card_info">
                  <!-- 世界妈祖庙列表展示 -->
                  {{$t("welcome.t3")}}
                </div>
                <img src="@/assets/img/card3.png" alt />
              </div>
            </el-col>
            <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
              <div class="item_card" @click="toPage('/articleList',4)">
                <div class="card_title">
                  <!-- 文章列表 -->
                  {{$t("menu.article")}}
                </div>
                <div class="card_info">
                  <!-- 妈祖历史与文章资讯 -->
                  {{$t("welcome.t4")}}
                </div>
                <img src="@/assets/img/card4.png" alt />
              </div>
            </el-col>
          </el-row>
        </div>
        <!-- 2 -->
        <div class="mz_items">
          <el-row :gutter="20">
            <el-col :xs="24" :sm="12" :md="16" :lg="16" :xl="16">

              <div class="thing animated zoomIn">
                <div class="mod_card animated fadeInDown">
                  <!-- 梳妆楼 -->
                  <div class="mod"> <span> {{$t("welcome.t5")}}</span></div>
                </div>
                <!-- <div class="mod_card animated fadeInDown">
                  <div class="mod mod_two"> <span>{{$t("welcome.t6")}}</span></div>
                </div> -->

                <div class="thing_card animated fadeInUp"> <img src="@/assets/img/wp_2.png" alt /></div>
                <div class="thing_card animated fadeInDown"> <img src="@/assets/img/wp_1.png" alt /></div>
              </div>
            </el-col>

            <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
              <div class="stone animated zoomInRight">
                <img src="@/assets/img/stone.png" alt />
                <div class="stone_box">
                  <!-- 石狮子 -->
                  <div class="title"> {{$t("welcome.t7")}}</div>
                  <div class="info">
                    <!-- 威严尊贵石狮雄， -->
                    <p>{{$t("welcome.t8")}}</p>
                    <!-- 纳吉驱邪美德崇。 -->
                    <p>{{$t("welcome.t9")}}</p>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <div class="footer">
      <!-- 厦门理工学院 • 空间模拟与智慧城市实验室 -->
      <p> <a href="http://xmutsrsc.com/" target="_blank"> 厦门理工学院 • 空间模拟与智慧城市实验室</a>
      </p>
      <!-- Spatial Reality and Smart City Lab, SRSC -->
      <p><a href="http://xmutsrsc.com/" target="_blank">Spatial Reality and Smart City Lab, SRSC</a>
      </p>
      <!-- 厦门市集美区理工路600号 邮编：361024 -->
      <p> <i class="el-icon-location-outline"></i> {{$t("common.address")}}
        <i style="margin-left: 0.6rem" class="el-icon-message"></i>
        {{$t("common.postal")}}：361024
      </p>
    </div>
  </div>
</template>

<script>
import MyBanner from "../../components/MyBanner.vue";
// import { mapState } from "vuex";
export default {
  name: "Welcome",
  components: {
    MyBanner,
  },
  computed: {
    // ...mapState({
    //   test: (state) => {
    //     return state.home.bannerList;
    //   },
    // }),
  },
  filters: {
    timeFilter(time) {
      if (time) {
        return time.substring(0, 10);
      }
    },
  },

  data() {
    return {
      articleTypeArr: [], //文章分类列表
      articleList: [],
    };
  },
  created() {
    //  初始化公共参数
    this.getArticle(1);
    this.getArticle(2);
  },
  mounted() {
    // 获取字典数据
    // this.$store.dispatch("getdictList");
    // this.$store.dispatch("getCommons");
  },
  methods: {
    toPage(path, i) {
      // 若当前路由地址与目标地址相同，则return
      if (this.$route.path == path) {
        return;
      }
      if (path.substr(0, 1) == "/") {
        // this.selectMark = i;
        //未登录则去登陆
        if (i != 0 && !sessionStorage.getItem("user")) {
          this.$router.push("/login");
          return;
        }
        this.$router.push(path);
        sessionStorage.setItem("path", i); //存放在session里
      }
      // 站外页面跳转
      else {
        window.open(path);
        // 跳转网页后，网站会到首页
        // this.$router.push("/home"); //跳转到登录页
      }
      this.activeName = "0";
    },

    getArticle(type) {
      let parData = {
        page: 1,
        pageSize: 25,
        query: "",
        state: "1",
        titleClass: type,
      };
      this.$Loading.show();
      this.http.post("article/getArticlePage", parData).then((res) => {
        this.$Loading.hide();
        if (res.code == "0") {
          let list = res.data.records;
          let baseList = {
            title: type,
            record: list,
          };
          this.articleList.push(baseList);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 跳转到文章详情
    toArticle(row) {
      this.$router.push(
        "/article?id=" +
          row.id +
          "&name=" +
          row.title_name +
          "&type=" +
          row.title_class
      );
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/_common.scss";

.body_box {
  // border: 1px solid red;

  margin: 0 auto;
}
.banner {
  max-width: 120rem;
  height: 40rem;
  margin: 0 auto;
  margin-top: calc($head-height + 1rem);
}

.main {
  max-width: 120rem;
  margin: 0 auto;
  box-sizing: border-box;
  // margin-top: $m-mid;
  .card_main {
    width: 100%;
    box-sizing: border-box;
    padding: $m-mid 0;

    .item_card {
      margin-top: $m-lit;
      height: 12rem;
      border-radius: $r-big;
      box-shadow: $shadow;
      padding: $m-mid;
      background-color: $c-white;
      position: relative;
      cursor: pointer;
      transition: all 0.3s;
      .card_title {
        font-size: $f-hug;
        font-weight: 700;
        font-family: "syBlack_r";
        color: $c-text-main;
        transition: all 0.3s;
      }
      .card_info {
      }

      img {
        position: absolute;
        right: $m-lit;
        bottom: $m-lit;
        height: 60%;
        width: auto;
        transition: all 0.3s;
      }
      &:hover {
        box-shadow: $shadow-hover;
        .card_title {
          color: $c-main;
          font-size: calc($f-hug * 1.2);
        }

        .card_info {
        }

        img {
          height: 70%;
        }
      }
    }
  }
  // 1
  .mz_info {
    .line {
      margin-top: $m-lit;
      height: 6px;
      background: url("../../assets/img/line.png") repeat-x left bottom;
    }
    .line_two {
      margin-top: $m-lit;
      height: 6px;
      background: url("../../assets/img/line_2.png") repeat-x left bottom;
    }
    .history_box {
      display: flex;
      justify-content: center;
      height: 24rem;
      margin-top: $m-mid;
      border-radius: $r-mid;
      overflow: hidden;
      .history {
        background: url("../../assets/img/f3.png");
        border: $b-border-white;
        width: 60%;
        .title {
          color: $c-text-main;
          font-size: $f-hug;
          padding: $m-lit 0;
          margin: 0 $m-mid;
          font-family: "syBlack_r";
          text-align: center;
        }
        ul {
          margin: 0;
          padding: 0;
          height: 20rem;
          overflow: hidden;
          overflow-y: auto;

          li {
            margin: 0 $m-mid;
            color: $c-text-main;
            font-size: $f-big;
            cursor: pointer;
            list-style: none;
            box-sizing: border-box;
            border-bottom: $b-border-white;
            position: relative;
            display: flex;
            align-items: center;
            i {
              color: $c-yellow;
            }
            div {
              height: 2.5rem;
              line-height: 2.5rem;
              display: inline-block;
              width: 75%;
              white-space: nowrap;
              overflow: hidden; //内容超出隐藏
              text-overflow: ellipsis;
              margin-left: $m-min;
            }
            span {
              margin-right: $m-mid;
              position: absolute;
              right: 0;
            }
            &:hover {
              color: $c-yellow;
              border-bottom: 1px solid $c-yellow;
              i {
                color: $c-second;
              }
            }
          }
        }
      }
      .history_img {
        width: 40%;
        overflow: hidden;
        height: 24rem;
        img {
          width: 100%;
          height: 100%;
          transition: all 1s;
          &:hover {
            transform: scale(1.1);
          }
        }
      }
    }
    .news {
      background: url("../../assets/img/f5.png");
      width: 100%;
      margin-top: $m-mid;
      height: 24rem;
      overflow: hidden;
      border-left: $b-border-white;
      border-radius: $r-mid;
      .title {
        color: $c-text-white;
        font-size: $f-hug;
        margin: 0 $m-mid;
        font-family: "syBlack_r";
        text-align: center;
      }
      img {
        width: 100%;
        height: 100%;
        transition: all 1s;
        &:hover {
          transform: scale(1.1);
        }
      }
      ul {
        margin: 0;
        padding: 0;
        height: 24rem;
        overflow: hidden;
        overflow-y: auto;
        li {
          margin: 0 $m-mid;
          color: $c-text-white;
          font-size: $f-big;
          cursor: pointer;
          list-style: none;
          box-sizing: border-box;
          position: relative;
          display: flex;
          align-items: center;

          i {
            color: $c-yellow;
          }
          div {
            height: 2.5rem;
            line-height: 2.5rem;
            display: inline-block;
            width: 60%;
            white-space: nowrap;
            overflow: hidden; //内容超出隐藏
            text-overflow: ellipsis;
            margin-left: $m-mid;
          }

          span {
            margin-right: $m-lit;
            position: absolute;
            right: 0;
          }
          &:hover {
            color: $c-yellow;
            border-bottom: 1px solid $c-yellow;
            &::before {
              background-color: $c-main;
            }
          }
        }
      }
    }
    .moreBtn {
      font-size: 16px;
      float: right;
      margin-top: $m-lit;
      cursor: pointer;

      &:hover {
        color: $c-yellow;
      }
    }
  }
  // 2
  .mz_items {
    margin: $m-mid 0;
    .stone {
      background-color: $c-black;
      height: 24rem;
      display: flex;
      align-items: flex-end;
      padding: $m-mid;
      box-sizing: border-box;
      img {
        height: 120%;
        width: auto;
        vertical-align: middle;
        margin-right: $m-lit;
        transition: all 0.3s;
        &:hover {
          transform: scale(1.1);
        }
      }
      .stone_box {
        height: 100%;
        width: 100%;
        color: $c-white;
        .title {
          font-size: calc($f-hug * 2);
          text-align: center;
        }
        .info {
          font-size: $f-hug;
          p {
            margin: $m-lit;
          }
        }
      }
    }
    .thing {
      background-color: $c-black;
      height: 24rem;
      display: flex;
      justify-content: space-around;
      box-sizing: border-box;
      .mod_card {
        // width: 600px;
        width: 50%;
        height: 100%;
        background-color: rgb(255, 255, 255);
        .mod {
          position: relative;
          z-index: 999;
          height: 100%;
          width: 100%;
          margin: 0 auto;
          background: url("../../assets/img/mod/szl_mod.png");
          background-size: 2000% 100%;
          cursor: pointer;
          // background-position: 0px 0px;
          overflow: hidden;
          &:hover {
            animation: run 3s steps(20, start) infinite;
            // -webkit-animation: run 0.5s steps(20) infinite;
            // -moz-animation: run 0.5s steps(20) infinite;
            // -o-animation: run 0.5s steps(20) infinite;
            // animation: run 0.5s steps(20) infinite;
            span {
              // display: block;
              opacity: 1;
              margin-bottom: 0rem;
            }
          }

          span {
            position: absolute;
            width: 100%;
            height: 4rem;

            color: $c-white;
            left: 0;
            bottom: 0;
            text-align: center;
            font-size: $f-hug;
            line-height: 4rem;
            // display: none;
            opacity: 0;
            transition: all 0.5s;
            margin-bottom: -4rem;
            background: url("../../assets/img/wl_5.png") repeat-x left bottom;
            background-color: rgba(0, 0, 0, 0.2);
          }
        }

        .mod_two {
          background: url("../../assets/img/mod/tzd_mod.png");
          background-size: 2000% 100%;
        }
      }

      @keyframes run {
        from {
          background-position: 0% 0;
        }

        to {
          background-position: -2000% 0;
        }
      }

      @-webkit-keyframes run {
        from {
          background-position: 0% 0;
        }

        to {
          background-position: -2000% 0;
        }
      }

      @-moz-keyframes run {
        from {
          background-position: 0% 0;
        }

        to {
          background-position: -2000% 0;
        }
      }

      @-o-keyframes run {
        from {
          background-position: 0% 0;
        }
        to {
          background-position: -2000% 0;
        }
      }

      .thing_card {
        width: 50%;
        height: 24rem;
        display: flex;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;

        &:nth-child(1) {
          background-color: rgb(91, 91, 91);
        }
        &:nth-child(2) {
          background-color: rgb(55, 66, 65);
        }
        &:nth-child(3) {
          background-color: rgb(59, 59, 59);
        }
        img {
          width: auto;
          height: auto;
          max-height: 90%;
          max-width: 90%;
          // vertical-align: middle;
          // margin-right: $m-lit;
          transition: all 0.3s;
          &:hover {
            transform: scale(1.1);
          }
        }
      }
    }
  }
}
.footer {
  width: 100%;
  color: $c-white;
  font-size: $f-lit;
  box-sizing: border-box;
  text-align: center;
  padding: $m-min 0;
  background: url("../../assets/img/wl_5.png") repeat-x left bottom;
  background-color: $c-black;
  p {
    margin: 0;
    padding: 0;
    a {
      color: $c-white;
      text-decoration: none;
    }
  }
}
@media screen and (min-width: 651px) and (max-width: 1100px) {
  .banner {
    height: 30rem;
  }
}
@media screen and (min-width: 451px) and (max-width: 650px) {
  .banner {
    height: 20rem;
  }
  .main {
    box-sizing: border-box;
    min-height: 30rem;
    .card_main {
      width: 100%;
      box-sizing: border-box;
      padding: $m-mid;
      .item_card {
        margin-top: $m-mid;
        height: 12rem;
        border-radius: $r-big;
        box-shadow: $shadow;
        padding: $m-mid;
        background-color: $c-white;
        position: relative;
        cursor: pointer;
        transition: all 0.3s;
        .card_title {
          font-size: $f-hug;
          font-weight: 700;
          font-family: "syBlack_r";
          color: $c-text-main;
          transition: all 0.3s;
        }
        .card_info {
        }

        img {
          position: absolute;
          right: $m-lit;
          bottom: $m-lit;
          height: 60%;
          width: auto;
          transition: all 0.3s;
        }
        &:hover {
          box-shadow: $shadow-hover;
          .card_title {
            color: $c-main;
            font-size: calc($f-hug * 1.2);
          }

          .card_info {
          }

          img {
            height: 70%;
          }
        }
      }
    }
  }
  .footer {
    width: 100%;
    background-color: $c-black;
    color: $c-white;
    font-size: $f-lit;
    box-sizing: border-box;
    text-align: center;
    padding: $m-min 0;
    p {
      margin: 0;
      padding: 0;
      a {
        color: $c-white;
        text-decoration: none;
      }
    }
  }
}
@media screen and (max-width: 450px) {
  .banner {
    height: 15rem;
  }
  .main {
    .mz_info {
      .history_box {
        display: block;
        .history {
          width: 100%;
        }
        .history_img {
          display: none;
        }
      }
    }
    // 2
    .mz_items {
      .stone {
        img {
          height: 110%;
        }
        .stone_box {
          .title {
            font-size: $f-hug;
          }
          .info {
            font-size: $f-big;
          }
        }
      }
      .thing {
        height: 60rem;
        display: block;
        .mod_card,
        .thing_card {
          width: 100%;
          height: 20rem;
        }
      }
    }
  }
}
</style>